"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'googleDrive.picker.title': 'Wybierz plik z Google Drive',
    'googleDrive.picker.selectFile': 'Wybierz plik z Google Drive',
    'googleDrive.picker.selectFiles': 'Wybierz pliki z Google Drive',
    'googleDrive.picker.loading': 'Ładowanie API Google Drive...',
    'googleDrive.picker.initializing': 'Inicjalizacja selektora plików...',
    'googleDrive.picker.notAuthenticated': 'Google Drive nie połączony',
    'googleDrive.picker.statusError': 'Błąd sprawdzania statusu Google Drive',
    'googleDrive.picker.filesLoadError': 'Błąd ładowania plików',
    'googleDrive.picker.checkingAuth': 'Sprawdzanie uwierzytelnienia...',
    'googleDrive.picker.authRequired': 'Najpierw połącz swoje konto Google Drive',
    'googleDrive.picker.connectAccount': 'Połącz Google Drive',
    'googleDrive.picker.loadingFiles': 'Ładowanie plików z Google Drive...',
    'googleDrive.picker.noFiles': 'Nie znaleziono plików',
    'googleDrive.picker.noFilesDesc': 'Twój Google Drive wydaje się być pusty',
    'googleDrive.picker.refresh': 'Odśwież',
    'googleDrive.picker.searchPlaceholder': 'Szukaj plików...',
    'googleDrive.picker.filesFound': 'znalezionych plików',
    'googleDrive.picker.initError': 'Nie udało się zainicjalizować wyboru plików z Google Drive',
    'googleDrive.picker.loadingError': 'Nie udało się załadować API Google Drive',
    'googleDrive.picker.noAccessToken': 'Token dostępu niedostępny',
    'googleDrive.picker.error': 'Błąd wyboru plików z Google Drive',
    'googleDrive.picker.fileSelected': 'Plik wybrany',
    'googleDrive.picker.filesSelected': 'plików wybranych',
    'googleDrive.picker.authError': 'Uwierzytelnianie Google nie powiodło się',
    'googleDrive.picker.configError': 'Błąd konfiguracji Google',
    'googleDrive.picker.selectDirectory': 'Wybierz katalog Google Drive',
    'googleDrive.picker.createError': 'Błąd otwierania selektora Google Drive',
    'googleDrive.picker.connectFirst': 'Proszę najpierw połączyć Google Drive w ustawieniach',
    'googleDrive.picker.tokenExpired': 'Dostęp do Google Drive wygasł. Proszę ponownie połączyć konto Google Drive w ustawieniach.',
    'googleDrive.picker.refreshFailed': 'Błąd odświeżania dostępu do Google Drive. Proszę ponownie połączyć konto w ustawieniach.',
};
